// extracted by mini-css-extract-plugin
export var drawerPaper = "_1v-0";
export var itemCard = "_1v-1";
export var itemImage = "_1v-2";